<template>
    <div class="q-pa-md q-gutter-sm">
        <q-dialog :value="value" persistent maximized transition-show="slide-up" @input="$emit('input', $event)" @hide="$emit('input', false)">
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Estados de Cuenta</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table :data="data" :columns="columns" row-key="name" >
                        <template v-slot:top-right>
                            <q-input borderless dense debounce="300" v-model="filter" placeholder="Filtrar">
                            <template v-slot:append>
                                <q-icon name="search" />
                            </template>
                            </q-input>
                            <q-btn push color="white" text-color="primary" round icon="mdi-plus" @click="dilogNuevoEstado=true">
                                <q-tooltip content-class="bg-accent">Nuevo Estado de Cuenta</q-tooltip>
                            </q-btn>
                            <q-btn push color="white" text-color="primary" round icon="mdi-reload" @click="getMovimientos()">
                                <q-tooltip content-class="bg-accent">Actualizar Lista</q-tooltip>
                            </q-btn>
                        </template>
                        <template v-slot:body-cell-acciones="props">
                            <q-td :props="props">
                            <q-btn icon="mdi-dots-vertical" round dense flat color="primary" @click="verMovimientos(props.row)">
                                <q-tooltip>Ver Movimientos</q-tooltip>
                            </q-btn>
                            </q-td>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dilogNuevoEstado">
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Cargue su estado de cuenta</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-uploader class="full-width" accept=".pdf,application/pdf" @rejected="onRejected" @added="onFileAdded">
                        <template v-slot:header="scope">
                            <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                            <q-btn v-if="scope.queuedFiles.length > 0" icon="clear_all" @click="limpiarArchivo(scope)" round dense flat >
                                <q-tooltip>Limpiar</q-tooltip>
                            </q-btn>
                            <q-spinner v-if="scope.isUploading" class="q-uploader__spinner" />
                            <div class="col">
                                <div class="q-uploader__title">Seleccione o Arrastre su Estado de Cuenta en PDF</div>
                            </div>
                            <q-btn v-if="scope.canAddFiles" type="a" icon="add_box" @click="scope.pickFiles" round dense flat>
                                <q-uploader-add-trigger />
                                <q-tooltip>Pick Files</q-tooltip>
                            </q-btn>
                            </div>
                        </template>
                        <template v-slot:list="scope">
                            <q-list separator>
                            <q-item v-for="file in scope.files" :key="file.__key">
                                <q-item-section>
                                    <q-item-label class="full-width ellipsis text-weight-bold"">
                                        {{ file.name }}
                                    </q-item-label>
                                    <q-item-label caption>
                                        {{ file.__sizeLabel }}
                                    </q-item-label>
                                </q-item-section>
                                <q-item-section top side>
                                    <q-btn class="gt-xs" size="12px" flat dense round icon="delete" @click="limpiarArchivo(scope)"/>
                                </q-item-section>
                            </q-item>
                            </q-list>
                        </template>
                    </q-uploader>
                    <q-btn class="full-width" color="primary" label="Leer Estado de Cuenta" @click="postPdf()"></q-btn>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogConfirmacion">
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Resultado del Esatdo de Cuenta</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-sm">
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.nombre" label="Descripción" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.rfc" label="RFC" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.banco" label="Banco" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.numCuenta" label="Num. Cuenta" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.moneda" label="Moneda" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.fechaInicial" label="Fecha Inicial" dense/>
                        </div>
                        <div class="col-12">
                            <q-input outlined v-model="objMovimientos.fechaFinal" label="Fecha Final" dense/>
                        </div>
                        <div class="col-12">
                            <q-btn class="full-width" color="primary" label="Guardar" @click="PostEstadoDeCuenta()"></q-btn>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
        <EstadoCuentaDet v-model="dialogDetalles"></EstadoCuentaDet>
    </div>
</template>
<script>
import { QSpinnerCube } from 'quasar'
import axios from 'axios'
import EstadoCuentaDet from './EstadoCuentaDet.vue';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
        EstadoCuentaDet,
    },
  data() {
    return {
        data: [],
        columns: [
            { name: 'acciones', align: 'center', label: 'Acciones', field: 'acciones', sortable: true },
            { name: 'descripcion', align: 'center', label: 'Descripción', field: 'descripcion', sortable: true },
            { name: 'banco', align: 'center', label: 'Banco', field: 'banco', sortable: true },
            { name: 'numCuenta', align: 'center', label: 'Num. Cuenta', field: 'numCuenta', sortable: true },
            { name: 'moneda', align: 'center', label: 'Moneda', field: 'moneda', sortable: true },
            { name: 'fechaInicial', align: 'center', label: 'Fecha Inicial', field: 'fechaInicial', sortable: true, field: row => row.fechaInicial, format: val => `${this.formatoFecha(val)}`, },
            { name: 'fechafinal', align: 'center', label: 'Fecha Final', field: 'fechafinal', sortable: true, field: row => row.fechafinal, format: val => `${this.formatoFecha(val)}`, },
        ],
        filter: null,

        //PARA GENERAR UN NUEVO ESTADO DE CUENTA
        dilogNuevoEstado: false,
        archivoSeleccionado: null,

        //PARA GUARDAR LOS MOVIMIENTOS BANCARIOS
        dialogConfirmacion: false,
        objMovimientos: {
            nombre: null,
            rfc: null,
            banco: null,
            numCuenta: null,
            moneda: null,
            fechaInicial: null,
            fechaFinal: null,
            fechaCorte: null,
            usuario: "Pruebas",
        },
        cuentaMovimientos: 0,
        listMovimientos: null,

        rutaApi: "https://api-blenter.contago.com.mx/api/",

        //DETALLES
        dialogDetalles: false
    }
  },
    computed: {
        token() {
            return this.$store.state.usuario;
        },
    },
    
    async created() {
        await this.getMovimientos();
    },

   methods: {
    async postPdf(){
        const archivo = this.archivoSeleccionado;
        if (!archivo) {
            this.$q.notify({ type: "warning", message: "Seleccione un Archivo" });
            return;
        }
        this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: 'Extrayendo datos...', messageColor: 'white' });
        const formData = new FormData();
        formData.append('template_id', 'b63a894b-0900-476c-8c41-251416fe30c5');
        formData.append('file', archivo);
        try{
            const responseScanner = await axios.post(
                    'https://sat-scanner-backend-494247865916.us-central1.run.app/api/analyze-document',
                    formData, {
                    headers: { 'X-API-Key': 'sk_live_yArm2gEnKC8V5acqO9A0DZHHAMi0-cDseJ2v0ysVMaI' }
                }
            );
            console.log(responseScanner.data.data);
            console.log(this.token);

            const respuesta = responseScanner.data.data.datos_extraidos
            this.objMovimientos.rfc = respuesta.rfc_cliente;
            this.objMovimientos.numCuenta = respuesta.numero_cuenta.toString();
            this.objMovimientos.banco = respuesta.banco;
            this.objMovimientos.moneda = "MXN";
            // this.objMovimientos.fechaInicial = respuesta.rfc_cliente;
            // this.objMovimientos.fechaFinal = respuesta.rfc_cliente;
            // this.objMovimientos.fechaCorte = respuesta.rfc_cliente;
            this.objMovimientos.usuario = this.token.nombre;
            this.listMovimientos = respuesta.movimientos;

            this.dialogConfirmacion = true;
            this.$q.loading.hide()
        }catch(error){
            console.log(error)
            this.$q.loading.hide()
        }
    },

    async PostEstadoDeCuenta(){
        //GUARDAMOS LA CABECERA
        this.$q.loading.show({ message: 'Guardando Estado de Cuenta'})
        const idCabecera = await this.PostCabecera();
        console.log(idCabecera)
        // if(!idCabecera){
        //     this.$q.notify({ type: "error", message: "Error al guardar, intente nuevamente" });
        //     this.$q.loading.hide()
        //     return;
        // }

        //GUARDAMOS LOS MOVIMIENTOS
        this.$q.loading.show({ message: 'Guardando Movimientos'})
        const contador = this.listMovimientos.length;
        var cuenta = 1;

        for(let i of this.listMovimientos){
            const detalle_ = {
                idMovBancario: idCabecera,
                fecha: i.fecha,
                folio: "",
                descripcion: i.descripcion,
                deposito: i.deposito,
                retiro: i.retiro,
                saldo: i.saldo,
                rfc: i.rfc,
                nombre: i.nombre
            }
            console.log(detalle_)
            await this.PostDetalles(detalle_);
            cuenta++;
        }
        this.$q.loading.hide()
    },

    async PostCabecera(){
        try{
            this.objMovimientos.fechaCorte = this.objMovimientos.fechaFinal;
            const obj = {...this.objMovimientos}
            const response = await axios.post(`https://api-blenter.contago.com.mx/api/MovBancarios/cabecera`, obj,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-RFC": this.token.rfc
                }
            });
            return response.data;
        }catch(error){
            console.log("CABECERA",error)
            return null;
        }
    },

    async PostDetalles(obj){
        try{
            const response = await axios.post(`https://api-blenter.contago.com.mx/api/MovBancarios/detalle`, obj,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-RFC": this.token.rfc
                }
            });
        }catch(error){
            console.log(error)
            return null;
        }
    },
    
    onFileAdded(files){
        this.archivoSeleccionado = files[0];
    },

     onRejected (rejectedEntries) {
      this.$q.notify({
        type: 'negative',
        message: `Sólo se permiten archivos en PDF`
      })
    },

    limpiarArchivo(scope) {
        scope.removeQueuedFiles();
        this.archivoSeleccionado = null;
    },

    //OBTENER MOVIMIENTOS
    async getMovimientos(){
        try{
            const response = await axios.get(`https://api-blenter.contago.com.mx/api/MovBancarios/activos`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-RFC": this.token.rfc
                }
            });
            this.data = response.data;
            console.log(response.data)
        }catch(error){
            console.log(error)
        }
    },

    async verMovimientos(item){
        try{
            const id = item.id
            const response = await axios.get(`https://api-blenter.contago.com.mx/api/MovBancarios/GetByIdMovPol/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-RFC": this.token.rfc
                }
            });
            const detalles = response.data;
            const obj = {
                ...item,
                detalles,
            }
            console.log(obj)
            this.$store.state.EstadoCuentaDet = null;
            this.$store.state.EstadoCuentaDet = obj;
            this.dialogDetalles = true;
        }catch(error){
            console.log(error)
        }
    },

    formatoFecha(fecha){
        const fechaTexto = fecha.toString();
        return fechaTexto.slice(0, 10)
    },

   }
};
</script>